import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';

const RootApp: React.FC = () => {
  if (import.meta.env?.DEV) {
    return (
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
  return <App />;
};

ReactDOM.createRoot(document.getElementById('root')!).render(<RootApp />);

export default RootApp;
